import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { Toast, ToastContainer } from 'react-bootstrap';
import { Clipboard, Check, HelpCircle } from 'lucide-react'; 
import ConfirmDeleteModal from '../../components/DeleteModal';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useAuth } from '../../Context/AuthContext';
import { BASE_URL } from '../../constants';
import { faCheck, faCog, faHome, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FaBed,FaEdit, FaTrashAlt, FaKey,FaPlus, FaDownload } from "react-icons/fa";
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


import Layout from '../../components/Layout';

import {
  Container,
  Form,
  Table,
  Button,
  Row,
   Pagination,
  Card,
  Col,
  Spinner,
  Modal,
  Alert,
  InputGroup
} from 'react-bootstrap';

import moment from 'moment';
import { CSVLink } from 'react-csv';

const RefugeeTable = () => {
  const [assignError, setAssignError] = useState(null);
const [originalRefugee, setOriginalRefugee] = useState(null);
  const [rooms, setRooms] = useState([]);
const [emailVerificationNotice, setEmailVerificationNotice] = useState(false);
  const [refugees, setRefugees] = useState([]);
  const [filteredRefugees, setFilteredRefugees] = useState([]);
  const [selectedRefugee, setSelectedRefugee] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
   const [showEditModal, setShowEditModal] = useState(false);
   const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [editForm, setEditForm] = useState({});
   const [selectedRole, setSelectedRole] = useState('all');
   const [showToast, setShowToast] = useState(false);
   const [toastMessage, setToastMessage] = useState('');
   const [copiedIndex, setCopiedIndex] = useState(null);
   const [copiedField, setCopiedField] = useState(null);
   const { user } = useAuth();  
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [numberOfClients, setNumberOfClients] = useState('');
  const [generatedRefugees, setGeneratedRefugees] = useState([]);
  const [message, setMessage] = useState(null);
  const [editableFields, setEditableFields] = useState({
    firstName: null,
    lastName: null,
  });
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [selectedRefugeeId, setSelectedRefugeeId] = useState(null);
  const [copied, setCopied] = useState(false);
  const [confirmReset, setConfirmReset] = useState(false); // whether we are confirming or showing password
const [selectedIdentifiant, setSelectedIdentifiant] = useState(null); // store selected identifiant
const [showTooltip, setShowTooltip] = useState(false);


const copyToClipboard = () => {
  navigator.clipboard.writeText(newPassword).then(() => {
    setCopied(true);
    setShowTooltip(true);

    setTimeout(() => {
      setCopied(false);
      setShowTooltip(false);
    }, 2000);
  }).catch(err => {
    console.error('Failed to copy:', err);
  });
};

const handleCopy = (value, index, field) => {
  navigator.clipboard.writeText(value);
  setCopiedIndex(index);
  setCopiedField(field);
  setTimeout(() => {
    setCopiedIndex(null);
    setCopiedField(null);
  }, 1500);
};



  const shelterId = JSON.parse(localStorage.getItem('userData'))?.shelter?.id;
  const token = localStorage.getItem("token");

  const [showGenerateModal, setShowGenerateModal] = useState(false);
 const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(filteredRefugees.length / itemsPerPage);
 
  const handleForgotPassword = (identifiant) => {
    setSelectedIdentifiant(identifiant);
    setConfirmReset(true); // first, open modal in confirmation mode
    setShowPasswordModal(true);
  };
  const fetchRooms = async () => {
    try {
      if (!shelterId) return;
      const response = await axios.get(`${BASE_URL}/accommodation/shelter/${shelterId}`);
    
      setRooms(response.data.rooms); 
      
    } catch (error) {
      console.error("Error fetching rooms data:", error);
    }
  };
  
  useEffect(() => {
    fetchRooms();
    if (showEditModal) {
      setAssignError(null);
      setAlertMessage(null);
      fetchRooms();
    }
  }, [showEditModal]);
  

  const generateNewPassword = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/refugees/reset-password`, {
        identifiant: selectedIdentifiant,
      });
  
      setNewPassword(response.data.newPassword);
      setConfirmReset(false); // now show password instead of confirmation
    } catch (error) {
      console.error('Failed to generate password', error);
      alert('Error generating password');
      setShowPasswordModal(false);
    }
  };
 const assignRefugeeToRoom = async (userId, roomId, token) => {
    try {
      const response = await axios.post(`${BASE_URL}/accommodation/assign`, {
        userId,
        roomId
      }, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
  
      return response.data; // returns { message, room }
    } catch (error) {
      console.error("Assign room error:", error.response?.data || error.message);
      throw error;
    }
  };
  




  const fetchRefugees = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/refugees/shelter/${shelterId}`);
      setRefugees(res.data);
      setFilteredRefugees(res.data);
    } catch (error) {
      console.error('Error fetching refugees:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRefugees();
  }, []);

  useEffect(() => {
    const lowerSearch = search.toLowerCase();
    const filtered = refugees.filter((ref) => {
      return (
        (ref.identifiant && ref.identifiant.toLowerCase().includes(lowerSearch)) ||
        (ref.firstName && ref.firstName.toLowerCase().includes(lowerSearch)) ||
        (ref.lastName && ref.lastName.toLowerCase().includes(lowerSearch))
      );
    });
    setFilteredRefugees(filtered);
  }, [search, refugees]);

  const handleGenerate = async () => {
    if (!numberOfClients || isNaN(numberOfClients)) {
      setMessage({ type: 'danger', text: 'Please enter a valid number.' });
      return;
    }
  
    setGenerating(true);
    setMessage(null);
    try {
      const res = await axios.post(`${BASE_URL}/refugees/register-refugees`, {
        numberOfClients: parseInt(numberOfClients),
        shelterId: shelterId,
      });


      if (res.data?.clients) {
        setGeneratedRefugees(res.data.clients);
        setMessage({
          type: 'success',
          text: res.data.message || 'Users generated successfully.',
        });
        setNumberOfClients('');
        fetchRefugees();
  
        setTimeout(() => {
          setMessage(null);
          setShowGenerateModal(false);
        }, 2000); 
      }
    } catch (error) {
      const backendMessage = error.response?.data?.message || 'Failed to generate users.';
    console.error('Error generating users:', backendMessage);
    setMessage({ type: 'danger', text: backendMessage });
    } finally {
      setGenerating(false);
    }
  };
  
 
  const handleEditClick = (refugee) => {
    setEditForm(refugee);
    setShowEditModal(true);
    fetchRooms(); // fetch rooms when modal opens
  };
  
  const handleEdit = (refugee) => {
    const matchedRoom = rooms.find(room => room.roomNumber === refugee.roomNumber);
  setEditForm({
    ...refugee,
    roomId: matchedRoom ? matchedRoom._id : '', 
  });
    setShowEditModal(true);
  };
  const handleDeleteClick = (refugee) => {
    setSelectedRefugee(refugee);
    setSelectedRefugeeId(refugee._id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASE_URL}/users/${selectedRefugeeId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRefugees(prev => prev.filter(ref => ref._id !== selectedRefugeeId));
      setShowDeleteModal(false);
      setToastMessage('User deleted successfully!');
      setShowToast(true);
    } catch (error) {
      console.error('Error deleting user:', error);
    } finally {
      setLoading(false); 
    }
  };
const handleFormChange = (e) => {
  const { name, value } = e.target;
  setEditForm(prev => ({ ...prev, [name]: value }));
};

  
  const handleSaveChanges = async () => {
    setIsLoading(true);
    setAssignError(null);
    setAlertMessage(null);
  
    const token = localStorage.getItem("token");
  
    try {
      if (editForm.roomId && editForm.roomId === originalRefugee?.roomId) {
        setAssignError("This user is already assigned to this room.");
        return;
      }
  
      const formData = new FormData();
      formData.append("firstName", editForm.firstName);
      formData.append("lastName", editForm.lastName);
      if (editForm.email?.trim()) {
        formData.append("email", editForm.email);
      }
      formData.append("phone", editForm.phone);
      formData.append("gender", editForm.gender);
      formData.append("dateOfBirth", moment(editForm.dateOfBirth).toISOString());
if (editForm.entryDate) {
  formData.append("entryDate", new Date(editForm.entryDate).toISOString());
}

if (editForm.exitDate) {
  formData.append("exitDate", new Date(editForm.exitDate).toISOString());
}



      if (editForm.profilePhoto instanceof File) {
        formData.append("profilePhoto", editForm.profilePhoto);
      }
  
      const response = await axios.put(`${BASE_URL}/refugees/${editForm._id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response.status === 200) {
        setRefugees((prev) =>
          prev.map((r) => (r._id === editForm._id ? { ...r, ...response.data.user } : r))
        );
  
        if (!response.data.user.isEmailVerified && editForm.email?.trim() &&!editForm.email.endsWith('@noemail.refugee')) {
          setEmailVerificationNotice(true);
        } else {
          setEmailVerificationNotice(false);
        }
  
        let roomAssignedSuccessfully = true;
        if (editForm.roomId && editForm.roomId !== originalRefugee?.roomId) {
          try {
            await assignRefugeeToRoom(editForm._id, editForm.roomId, token);
          } catch (assignError) {
            roomAssignedSuccessfully = false;
            setAssignError(assignError.response?.data?.message || "Room assignment failed.");
          }
        }
  
        if (roomAssignedSuccessfully) {
          setAlertMessage("User updated successfully!");
          setShowAlert(true);
  
          setTimeout(() => {
            setAlertMessage(null);
            setShowAlert(false);
            setShowEditModal(false);
            
          });
          await fetchRefugees();
        }
      } else {
        setAssignError("Update failed. Please try again.");
      }
    } catch (error) {
      console.error("Error updating user:", error);
      setAssignError("Failed to update user details. Please try again.");
    } finally {
      setIsLoading(false);
    }
    
  };
  
  
      
      
      const csvHeaders = [
        { label: '#', key: 'index' },
        { label: 'Identifiant', key: 'identifiant' },
        { label: 'Password', key: 'password' }
      ];
      
      // Generate CSV data with index
      const csvData = generatedRefugees.map((client, index) => ({
        index: index + 1,
        identifiant: client.identifiant,
        password: client.password
      }));
      
  return (
    <Layout>




     <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-2">
          </div>
          <div className="table-settings">
          <Button
        variant="cyan" 
        onClick={() => setShowGenerateModal(true)}
        className="mb-3" 
        
      >
        <FontAwesomeIcon icon={faPlus} className="me-2" />
        <span className="small">Generate Users</span>
      </Button>
          </div>
          <Col>
            <div className="btn-toolbar mb-2 mb-md-0">
            <InputGroup className="w-50">
          <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
          <Form.Control
            placeholder="Search by name or ID"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
      
    
            </div>
          </Col>
      <Modal
        show={showGenerateModal}
        onHide={() => setShowGenerateModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Generate Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="generateCount">
            <Form.Label>Enter number of users to generate</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={numberOfClients}
              onChange={(e) => setNumberOfClients(e.target.value)}
              placeholder="e.g. 3"
            />
          </Form.Group>
          {message && (
            <Alert variant={message.type} className="mt-3 mb-0">
              {message.text}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowGenerateModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleGenerate} disabled={generating}>
            {generating ? <Spinner size="sm" animation="border" /> : 'Generate'}
          </Button>
        </Modal.Footer>
      </Modal>

      {generatedRefugees.length > 0 && (
  <div className="mt-3">
    <div className="d-flex justify-content-between align-items-center">
      <h5>Generated Users</h5>
      <CSVLink
  data={csvData}
  headers={csvHeaders}
  filename="generated_refugees.csv"
  className="btn btn-sm btn-success d-flex align-items-center gap-2"
>
  <FaDownload />
  Export CSV
</CSVLink>
    </div>

    <Card border="light" className="shadow-sm mt-3">
      <Card.Body className="pt-0">
      <Table hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Identifiant</th>
              <th>Password</th>
            </tr>
          </thead>
          <tbody>
        {generatedRefugees.map((client, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>
  {client.identifiant}{' '}
  <OverlayTrigger
    placement="top"
    overlay={
      <Tooltip>
        {copiedIndex === index && copiedField === 'identifiant'
          ? 'Copied!'
          : 'Copy identifiant'}
      </Tooltip>
    }
  >
    <span
      onClick={() =>
        handleCopy(client.identifiant, index, 'identifiant')
      }
      style={{ cursor: 'pointer', marginLeft: 5 }}
    >
      {copiedIndex === index && copiedField === 'identifiant' ? (
        <Check size={20} color="green" />
      ) : (
        <Clipboard size={20} />
      )}
    </span>
  </OverlayTrigger>
</td>
            <td>
  {client.password}{' '}
  <OverlayTrigger
    placement="top"
    overlay={
      <Tooltip>
        {copiedIndex === index && copiedField === 'password'
          ? 'Copied!'
          : 'Copy Password'}
      </Tooltip>
    }
  >
    <span
      onClick={() =>
        handleCopy(client.password, index, 'password')
      }
      style={{ cursor: 'pointer', marginLeft: 5 }}
    >
      {copiedIndex === index && copiedField === 'password' ? (
        <Check size={20} color="green" />
      ) : (
        <Clipboard size={20} />
      )}
    </span>
  </OverlayTrigger>
</td>

          </tr>
        ))}
      </tbody>
        </Table>
      </Card.Body>
    </Card>
  </div>
)}
      {loading ? (
        <div className="text-center my-4">
        <div className="spinner-border text-primary" role="status" />
      </div>
  ) :rooms.length === 0 ? (
  <div className="card mt-3">
    <div className="card-body">
      <p className="card-text">
        No rooms available. Please create a room first to add new Users to your shelter.
      </p>
    </div>
  </div>
) : (
  <>
{filteredRefugees && filteredRefugees.length > 0 ? (
  loading ? (
    <div>Loading Users...</div>
  ) : (
    <Card border="light" className="shadow-sm mt-3">
      <Card.Body className="pt-0">
       <Table hover responsive>
          <thead>
            <tr>
              <th className="text-center">#</th>
              <th className="text-center">Identifiant</th>
              <th className="text-center">Name</th>
              <th className="text-center">Email</th>
              <th className="text-center">Entry Date</th>
              <th className="text-center">Exit Date</th>
              <th className="text-center">Phone</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
          {[...filteredRefugees]
  .sort((a, b) => new Date(b.entryDate) - new Date(a.entryDate))
  .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
  .map((refugee, index) => (
    <tr key={refugee._id}>
      <td className="text-center">
        {(currentPage - 1) * itemsPerPage + index + 1}
      </td>
      <td className="text-center">{refugee.identifiant || '-'}</td>
      <td className="text-center">
        {(refugee.firstName || '-') + ' ' + (refugee.lastName || '-')}
      </td>
      <td className="text-center">{refugee.email || '-'}</td>
      <td className="text-center">
  {refugee.entryDate ? new Date(refugee.entryDate).toLocaleDateString() : '-'}
</td>
<td className="text-center">
  {refugee.exitDate ? new Date(refugee.exitDate).toLocaleDateString() : '-'}
</td>

      <td className="text-center">{refugee.phone || '-'}</td>
      <td className="text-center">
        <>
       
          <Button
            className="me-2 btn-warning btn-sm"
            onClick={() => handleForgotPassword(refugee.identifiant)}
          >
            <FaKey />
          </Button>

          <Button
            className="me-2 btn-primary btn-sm"
            onClick={() => handleEdit(refugee)}
          >
            <FaEdit />
          </Button>
          <Button variant="danger" size="sm" onClick={() => handleDeleteClick(refugee)}>
                            <FaTrashAlt />
                          </Button>
             </>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>

        <Pagination className="mt-3">
          <Pagination.Prev
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </Pagination.Prev>
          {[...Array(totalPages)].map((_, index) => (
            <Pagination.Item
              key={index}
              active={index + 1 === currentPage}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </Pagination.Next>
        </Pagination>
      </Card.Body>
    </Card>
  )
  
) : (
  <div className="card mt-3">
  <div className="card-body">
    <p className="card-text">Currently, there are no Users found.</p>
  </div>
</div>
)}

<Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Edit Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group controlId="formFirstName">
        <Form.Label>First Name</Form.Label>
        <Form.Control
          type="text"
          name="firstName"
          value={editForm.firstName || ''}
          onChange={handleFormChange}
          placeholder="Enter first name"
        />
      </Form.Group>
      <Form.Group controlId="formLastName">
        <Form.Label>Last Name</Form.Label>
        <Form.Control
          type="text"
          name="lastName"
          value={editForm.lastName || ''}
          onChange={handleFormChange}
          placeholder="Enter last name"
        />
      </Form.Group>
      <Form.Group controlId="formEmail">
     {emailVerificationNotice && (
             <Col md={12}>
                 <ToastContainer position="top-end" className="p-3">
  <Toast
    show={emailVerificationNotice}
    onClose={() => setEmailVerificationNotice(false)}
    bg="warning"
    delay={5000}
    autohide
  >
    <Toast.Header>
      <strong className="me-auto">Verification Email Sent</strong>
    </Toast.Header>
    <Toast.Body>
      A verification email has been sent. Please check your inbox to activate your email.
    </Toast.Body>
  </Toast>
</ToastContainer>

             </Col>
         )}

        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          name="email"
          value={editForm.email || ''}
          onChange={handleFormChange}
          placeholder="Enter email address"
        />
      </Form.Group>
      <Form.Group controlId="formPhone">
        <Form.Label>Phone</Form.Label>
        <Form.Control
          type="text"
          name="phone"
          value={editForm.phone || ''}
          onChange={handleFormChange}
          placeholder="Enter phone number"
        />
      </Form.Group>
    
      <Form.Group controlId="formRoom">
  <Form.Label>Assign Room</Form.Label>
  <Form.Control
    as="select"
    name="roomId"
    value={editForm.roomId || ''}
    onChange={handleFormChange}
  >
    <option value="">Select a room</option>
  {rooms
  .filter(room => room.capacity > 0) 
  .map(room => (
    <option key={room._id} value={room._id}>
      Room {room.roomNumber} (Capacity: {room.capacity})
    </option>
))}

  </Form.Control>
</Form.Group>
    


      <Form.Group controlId="formGender">
        <Form.Label>Gender</Form.Label>
        <Form.Control
          as="select"
          name="gender"
          value={editForm.gender || ''}
          onChange={handleFormChange}
        >
          <option value="">Select gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </Form.Control>
      </Form.Group>
      <Form.Group controlId="formDateOfBirth">
        <Form.Label>Date of Birth</Form.Label>
        <Form.Control
          type="date"
          name="dateOfBirth"
          value={moment(editForm.dateOfBirth).format('YYYY-MM-DD')}
          onChange={handleFormChange}
        />
      </Form.Group>
     <Form.Group controlId="formEntryDate">
  <Form.Label>Entry Date</Form.Label>
  <Form.Control
    type="date"
    name="entryDate"
    value={
      editForm.entryDate
        ? moment(editForm.entryDate).format("YYYY-MM-DD")
        : ""
    }
    onChange={handleFormChange}
  />
</Form.Group>

<Form.Group controlId="formExitDate">
  <Form.Label>Exit Date</Form.Label>
  <Form.Control
    type="date"
    name="exitDate"
    value={
      editForm.exitDate
        ? moment(editForm.exitDate).format("YYYY-MM-DD")
        : ""
    }
    onChange={handleFormChange}
  />
</Form.Group>

    </Form>
    <div className='mt-3'>
{assignError && <Alert variant="danger">{assignError}</Alert>}
{showAlert && <Alert variant="success">{alertMessage}</Alert>}
</div>

  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
      Cancel
    </Button>
      <Button variant="primary" onClick={handleSaveChanges} disabled={isLoading}>
      {isLoading ? (
        <>
          <Spinner animation="border" size="sm" role="status" className="me-2" />
        
        </>
      ) : (
        "Save Changes"
      )}
    </Button>
  </Modal.Footer>
</Modal>

      <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title className="fw-semibold">
      {confirmReset ? 'Confirm Password Reset' : '🔐 New Password'}
    </Modal.Title>
  </Modal.Header>

   <Modal.Body className="text-center p-4">
    {confirmReset ? (
      <>
        <HelpCircle size={64} color="#FFC107" strokeWidth={1.5} className="mb-3" />

        <h4 className="fw-bold mb-3">Are you sure?</h4>
        <p className="text-muted mb-4">
          Do you want to to generate a new password for this user <strong></strong>?
        </p>
        
        </>
    ) : (
      <div className="d-flex align-items-center justify-content-between border border-2 rounded-3 px-3 py-2 bg-light position-relative">
        <code className="text-dark fs-5">{newPassword}</code>

       
        <OverlayTrigger
  placement="top"
  show={showTooltip}
  onToggle={() => setShowTooltip(!showTooltip)}
  overlay={<Tooltip>{copied ? 'Copied!' : 'Copy Password'}</Tooltip>}
>
  <span onClick={copyToClipboard} style={{ cursor: 'pointer' }}>
    {copied ? <Check size={20} color="green" /> : <Clipboard size={20} />}
  </span>
</OverlayTrigger>
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    {confirmReset ? (
      <>
        <div className="d-flex justify-content-center gap-3">
        <Button variant="secondary"  style={{ backgroundColor: '#E0E0E0', color: '#333', border: 'none', minWidth: '120px' }} onClick={() => setShowPasswordModal(false)}>
          Cancel
        </Button>
        <Button variant="primary"  style={{  border: 'none', minWidth: '120px' }} onClick={generateNewPassword}>
          Generate
        </Button>
                 
        </div>
      </>
    ) : (
      <Button variant="secondary" onClick={() => setShowPasswordModal(false)}>
        Close
      </Button>
    )}
  </Modal.Footer>
</Modal>

<ConfirmDeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        itemName={selectedRefugee?.firstName && selectedRefugee?.lastName ? `${selectedRefugee.firstName} ${selectedRefugee.lastName}` : selectedRefugee?.identifiant || 'Unknown'}
        loading={loading}

      />
      <ToastContainer position="top-end" className="p-3">
  <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide bg="success">
    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
  </Toast>
  </ToastContainer>

 

</>
    )}
  </Layout>
);


};

export default RefugeeTable;